import { CompanyPolicyVersionHistoryModel } from './companyPolicyVersionHistoryModel';

export class AddCompanyPolicyVersionHistoryModel extends CompanyPolicyVersionHistoryModel {
public versionFile: File;
public companyPolicyId: number;
}
